// extracted by mini-css-extract-plugin
export var actionText = "_jb-4";
export var container = "_jb-0";
export var leftSection = "_jb-1";
export var rightSection = "_jb-2";
export var settingsButton = "_jb-6";
export var settingsIcon = "_jb-7";
export var shortcut = "_jb-5";
export var shortcutGroup = "_jb-3";